import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/layouts/appLayout.vue";
import router from "@/router";
import i18n from '@/lang/i18n';

if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/service-worker.js").then(() => { });
}

const app = createApp(App);

app.use(router)
    .use(createPinia())
    .use(i18n)
    .mount("#app");